





















import Vue from "vue";

import QuestionPanel from "@/modules/affiliates/components/question-panel/question-panel.vue";

import { IMatchingResponse } from "@/services/data/matching-responses/matching-response.interface";
import { IMatchingQuestion } from "@/services/data/matching-questionary/matching-question.interface";

import {
  IAffiliatesState,
  EAffiliatesActions,
} from "@/modules/affiliates/services/store/affiliates/affiliates.types";
import { EPxButtonType } from "@/components/px-button/px-button.types";

export default Vue.extend({
  name: "AffiliateQuestions",

  components: {
    QuestionPanel,
  },

  static: {
    backButton: {
      type: EPxButtonType.LINK_DARK,
    },
  },

  data() {
    return {
      textAreaLimit: 1500,
      hasResponse: false,
      currentResponse: {} as IMatchingResponse,
      updatedResponses: [] as Array<IMatchingResponse>,
    };
  },

  computed: {
    affiliatesData(): IAffiliatesState {
      return this.$store.state.affiliates;
    },

    questions(): Array<IMatchingQuestion> {
      return this.affiliatesData.affiliateQuestionBundle || [];
    },

    givenResponses(): Array<IMatchingResponse> {
      return this.affiliatesData.draftSubmission?.data.responses || [];
    },

    currentQuestion(): IMatchingQuestion | null {
      return this.questions?.length &&
        this.questions.length > this.currentSelectedQuestion
        ? this.questions[this.currentSelectedQuestion]
        : null;
    },

    hasCurrentQuestion(): boolean {
      return !!this.currentQuestion;
    },

    currentSelectedQuestion(): number {
      return this.affiliatesData.selectedQuestion;
    },

    backButtonProps(): any {
      return {
        ...this.$options.static.backButton,
        label: this.$t("affiliates.backToReview") as string,
        icon: "arrow--right-black",
      };
    },

    showReviewPageButton(): boolean {
      return this.affiliatesData.userNavigatingFromReviewPage || false;
    },
  },

  watch: {
    currentQuestion: {
      immediate: true,
      handler() {
        this.updateCurrentResponse();
      },
    },

    givenResponses: {
      immediate: true,
      handler() {
        this.updatedResponses = this.givenResponses;
      },
    },
  },

  methods: {
    validateResponseState(isValid: boolean) {
      this.hasResponse = isValid;

      this.updatedResponses = this.updatedResponses.map(
        (response: IMatchingResponse) => {
          if (response.question === this.currentResponse.question) {
            return {
              ...this.currentResponse,
              isValid: this.hasResponse,
            };
          }
          return response;
        },
      );

      this.$store.dispatch(
        EAffiliatesActions.SET_SUBMISSION_RESPONSES,
        this.updatedResponses,
      );
    },

    updateCurrentResponse() {
      if (!this.currentQuestion?.id) {
        return;
      }

      this.currentResponse = this.givenResponses.find(
        (response: IMatchingResponse) =>
          response.question === this.currentQuestion?.id,
      ) || {
        question: this.currentQuestion?.id,
        value: {},
        answers: [] as Array<number>,
      };
    },

    goToReviewPage() {
      this.$emit("go-to-review-page");
    },
  },
});
